import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../../context/LoadingContext";
import GpFinanceRfqsOffers from "./GpFinanceRfqsOffers";
const GpRfqsOffersModule = () => {

    const [activeTab, setActiveTab] = useState("RFQs");
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    const tabs = ["RFQs","Shortlisted Offers", "Negotiated Offers"];
    const renderTabContent = () => {
        switch (activeTab) {
            case "RFQs":
                return <GpFinanceRfqsOffers />;
            default:
                <GpFinanceRfqsOffers />
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab
                                        ? "active"
                                        : "notactive"
                                        }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default GpRfqsOffersModule;